
import Component, { mixins } from "vue-class-component"
import Calculator from "./mixins/Calculator.vue"
import AbgeschlosseneBestellungenLogic from "@/logic/abgeschlossene_bestellungen_logic"
import ErrorBox from "./custom/ErrorBox.vue"
import BestellungRow from "./custom/BestellungRow.vue"
import Bestellung from "@/entities/common/bestellung"
import Formatter from "@/logic/formatter"

@Component({ components: { BestellungRow, ErrorBox } })
export default class AbgeschlosseneBestellungen extends mixins(Calculator) {
  logic?: AbgeschlosseneBestellungenLogic = null

  mounted() {
    this.logic = new AbgeschlosseneBestellungenLogic()
    this.logic.init()
  }

  formatiereAbholungStatus(bestellung: Bestellung): string {
    return this.logic.formatiereAbholungStatus(bestellung)
  }

  formatiereLieferungStatus(bestellung: Bestellung): string {
    return this.logic.formatiereLieferungStatus(bestellung)
  }

  computeReservierungZeit(value: Bestellung): string {
    return (
      Formatter.formatiereDatum(value.reservierung.zeitVon) +
      " " +
      Formatter.formatiereUhrzeit(value.reservierung.zeitVon) +
      "-" +
      Formatter.formatiereUhrzeit(value.reservierung.zeitBis)
    )
  }

  detailsAnzeigen(bestellung: Bestellung) {
    this.logic.detailsAnzeigen(bestellung)
  }
}
